var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h2',[_vm._v("署名方式")]),_vm._v(" "),_c('div',{staticClass:"pt-2 pl-2",staticStyle:{"font-size":"1.7rem!important"}},[_vm._v("\n        "+_vm._s(_vm.getSignatureMethodText(_vm.signatureMethod))+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }